<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">订单信息</span>
        <el-button type="primary" plain class="title-btn" @click="cancel">返回</el-button>
      </div>
      <el-steps :active="4" align-center style="border-bottom:1px solid #E9E9E9;padding-bottom:20px;">
        <el-step title="准备充电" :description="rowdata.startTime" />
        <el-step title="开始充电" :description="rowdata.startTime" />
        <el-step title="结束充电" :description="rowdata.endTime" />
        <el-step title="订单支付" :description="rowdata.payTime" />
      </el-steps>
      <div style="margin-top:20px; margin-left: 100px; color:cornflowerblue; font-size: 20px;">订单结束原因：{{ rowdata.stopReasonDesc ? rowdata.stopReasonDesc : 'APP远程停止' }}</div>
      <div style="width:100%;height:110px;;display: flex; flex-direction: row; align-items:center; border-bottom:1px solid #E9E9E9;padding-left: 6%;">
        <div style="width: 300px;color:#999999;font-size:12px;">
          <div>订单总金额</div>
          <span style="color:#1890FF;font-size:36px;">{{ getFloat(rowdata.totalMoney) }}</span>
          <span style="color:#333333;">元</span>
        </div>
        <div style="width: 300px;color:#999999;font-size:12px;">
          <div>订单总优惠</div>
          <span style="color:#1890FF;font-size:36px;">{{ getFloat(rowdata.totalSavedMoney) }}</span>
          <span style="color:#333333;">元</span>
        </div>
        <div style="width: 300px;color:#999999;font-size:12px;">
          <div>实收金额</div>
          <span style="color:#1890FF;font-size:36px;">{{ getFixed2(rowdata.totalMoneyActual) }}</span>
          <span style="color:#333333;">元</span>
          <br>
          <span style="color:#1890FF">电费：{{ rowdata.elecMoneyActual }}&nbsp;&nbsp;&nbsp;服务费：{{ rowdata.seviceMoneyActual }}</span>
        </div>
      </div>
      <div class style="padding-left: 5%;padding-top:26px;">
        <SForm
          ref="formref"
          :fields="formfields"
          :data-form="rowdata"
          label-width="120px"
          :is-show-btn="false"
          form-style="width:30%"
          label-position="left"
        />
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">充电信息</span>
      </div>
      <el-table :data="tableData" border :summary-method="getSummaries" show-summary style="width: 100%;">
        <el-table-column prop="time" label="充电时段" />
        <el-table-column prop="eleMoney" label="电费单价(元/度)" />
        <el-table-column prop="serMoney" label="服务费单价(元/度)" />
        <el-table-column prop="power" label="充电度数(度)" />
        <el-table-column prop="money" label="费用(元)" />
      </el-table>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">优惠抵扣</span>
      </div>
      <div style="padding:10px;border:1px solid #e0e0e0">
        <div style="width:100%;font-size: 16px;">电站活动</div>
        <div style=" display: flex; flex-direction: row; justify-content: center;">
          <div style="width: 33%; ">
            <div>优惠电费</div>
            <div style="margin-top:10px">{{ rowdata.planDiscount?getFloat(rowdata.planDiscount.elecMoney):'--' }}元</div>
          </div>
          <div style="width: 33%; text-align: center;">
            <div>优惠服务费</div>
            <div style="margin-top:10px">{{ rowdata.planDiscount?getFloat(rowdata.planDiscount.seviceMoney):'--' }}元</div>
          </div>
          <div style="width: 33%; text-align: right;">
            <div>优惠总费用</div>
            <div style="margin-top:10px">{{ rowdata.planDiscount?getFloat(rowdata.planDiscount.totalMoney):'--' }}元</div>
          </div>
        </div>
      </div>
	  <div style="padding:10px;border:1px solid #e0e0e0;margin-top:10px">
	    <div style="width:100%;font-size: 16px;">权益抵扣<span style="font-size: 14px;">（权益编号：{{ rowdata.privilegeDiscount?rowdata.privilegeDiscount.sourceName:'--' }}）</span></div>
	    <div style="display: flex; flex-direction: row; justify-content: center;">
	      <div style="width: 33%; ">
	        <div>抵扣电费</div>
	        <div style="margin-top:10px">{{ rowdata.couponDiscount?getFloat(rowdata.privilegeDiscount.elecMoney):'--' }}元</div>
	      </div>
	      <div style="width: 33%; text-align: center;">
	        <div>抵扣服务费</div>
	        <div style="margin-top:10px">{{ rowdata.couponDiscount?getFloat(rowdata.privilegeDiscount.seviceMoney):'--' }}元</div>
	      </div>
	      <div style="width: 33%; text-align: right;">
	        <div>抵扣总费用</div>
	        <div style="margin-top:10px">{{ rowdata.couponDiscount?getFloat(rowdata.privilegeDiscount.totalMoney):'--' }}元</div>
	      </div>
	    </div>
	  </div>
      <div style="padding:10px;border:1px solid #e0e0e0;margin-top:10px">
        <div style="width:100%;font-size: 16px;">优惠券抵扣<span style="font-size: 14px;">（优惠券编号：{{ rowdata.couponDiscount?rowdata.couponDiscount.sourceName:'--' }}）</span></div>
        <div
          style="display: flex; flex-direction: row; justify-content: center;"
        >
          <div style="width: 33%; ">
            <div>抵扣电费</div>
            <div style="margin-top:10px">{{ rowdata.couponDiscount?getFloat(rowdata.couponDiscount.elecMoney):'--' }}元</div>
          </div>
          <div style="width: 33%; text-align: center;">
            <div>抵扣服务费</div>
            <div style="margin-top:10px">{{ rowdata.couponDiscount?getFloat(rowdata.couponDiscount.seviceMoney):'--' }}元</div>
          </div>
          <div style="width: 33%; text-align: right;">
            <div>抵扣总费用</div>
            <div style="margin-top:10px">{{ rowdata.couponDiscount?getFloat(rowdata.couponDiscount.totalMoney):'--' }}元</div>
          </div>
        </div>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">抹零费用</span>
      </div>
      <div
        style="padding-top: 20px; padding-bottom: 20px; display: flex; flex-direction: row; justify-content: center;"
      >
        <div style="width: 33%; ">
          <div>抹零电费</div>
          <div style="margin-top:10px">{{ rowdata.zeroDiscount?getFloat(rowdata.zeroDiscount.elecMoney):'--' }}元</div>
        </div>
        <div style="width: 33%; text-align: center;">
          <div>抹零服务费</div>
          <div style="margin-top:10px">{{ rowdata.zeroDiscount?getFloat(rowdata.zeroDiscount.seviceMoney):'--' }}元</div>
        </div>
        <div style="width: 33%; text-align: right;">
          <div>抹零总费用</div>
          <div style="margin-top:10px">{{ rowdata.zeroDiscount?getFloat(rowdata.zeroDiscount.totalMoney):'--' }}元</div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { HOST, EV_HOST } from '@/utils/host'
export default {
  name: 'AddEnterprise',
  components: {},
  data() {
    return {
      rowdata: {},
      formfields: [
        {
          label: '充电单号',
          type: 'div',
          style: 'width:100%',
          prop: 'startChargeSeq'
        },
        {
          label: '用户账号',
          type: 'div',
          style: 'width:100%',
          prop: 'loginName'
        },
        {
          label: '用户姓名',
          type: 'div',
          style: 'width:100%',
          prop: 'userName'
        },
        {
          label: '充电卡号',
          type: 'div',
          style: 'width:100%',
          prop: 'cardNum'
        },
        {
          label: '充电车辆',
          type: 'div',
          style: 'width:100%',
          prop: 'plateNumber'
        },
        {
          label: '归属企业',
          type: 'div',
          style: 'width:100%',
          prop: 'belongOrg'
        },
        // {
        //     label: "充电VIN码",
        //     type: "div",
        //     prop: "VINCode",
        // },
        {
          label: '运营商流水号',
          type: 'div',
          style: 'width:100%',
          prop: 'outStartChargeSeq'
        },
        {
          label: '流量方流水号',
          type: 'div',
          style: 'width:100%',
          prop: 'hlhtStartChargeSeq'
        },
        // {
        //     label: "订单类型",
        //     type: "div",
        //     prop: "orderType",
        // },
        // {
        //     label: "充电模式",
        //     type: "div",
        //     prop: "chargingType",
        // },
        {
          label: '终端名称',
          type: 'div',
          style: 'width:100%',
          prop: 'connectorName'
        },
        {
          label: '电桩品牌',
          type: 'div',
          style: 'width:100%',
          prop: 'equipmentBrand'
        },
        {
          label: '电桩型号',
          type: 'div',
          style: 'width:100%',
          prop: 'equipmentModel'
        },
        {
          label: '电桩功率',
          type: 'div',
          style: 'width:100%',
          prop: 'equipPower'
        },
        {
          label: '电站名称',
          type: 'div',
          style: 'width:100%',
          prop: 'stationName'
        },
        {
          label: '运营商',
          type: 'div',
          style: 'width:100%',
          prop: 'orgName'
        },
        {
          label: '运营商属性',
          type: 'div',
          style: 'width:100%',
          prop: 'attrValue'
        }
      ],

      tableData: [],
      id: ''
    }
  },
  computed: {},
  mounted() {
    this.getDataDetail()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.id = this.$route.query.data
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    cancel() {
      this.$router.go(-1)
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总时长：' + (this.rowdata.chargeTime)
          return
        }
        if (index === 3) {
          console.log(column, 'dddffff')
        }
        const values = data.map(item => Number(item[column.property]))
        console.log(column.property, 'ppouuh')
        if (column.property === 'power') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index]
        } else if (column.property === 'money') {
          sums[index] = this.rowdata.totalMoney
          sums[index]
        }
      })
      sums[3] = this.getFloat(sums[3])
      sums[4] = this.getFloat(sums[4])
      console.log(sums, 'ssss')

      return sums
    },

    getDataDetail() {
      const data = {
        id: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/finance/order/getHistoryOrderDetail',
        data: data,
        method: 'get',
        callback: resp => {
          this.rowdata = resp

          if (resp.chargeDetails) {
            const aa = JSON.parse(resp.chargeDetails)
            const bb = []
            if (!resp.outStartChargeSeq) {
              bb.push({ time: '尖时刻', eleMoney: aa['尖电费单价'], serMoney: aa['尖服务费单价'], power: aa['尖电量'], money: aa['尖金额'] })
              bb.push({ time: '峰时刻', eleMoney: aa['峰电费单价'], serMoney: aa['峰服务费单价'], power: aa['峰电量'], money: aa['峰金额'] })
              bb.push({ time: '平时刻', eleMoney: aa['平电费单价'], serMoney: aa['平服务费单价'], power: aa['平电量'], money: aa['平金额'] })
              bb.push({ time: '谷时刻', eleMoney: aa['谷电费单价'], serMoney: aa['谷服务费单价'], power: aa['谷电量'], money: aa['谷金额'] })
            } else {
              for (var i = 0; i < aa.length; i++) {
                bb.push({
                  time: aa[i].DetailStartTime + '~' + aa[i].DetailEndTime,
                  eleMoney: aa[i].ElecPrice,
                  serMoney: aa[i].SevicePrice,
                  power: aa[i].DetailPower,
                  money: aa[i].DetailElecMoney + aa[i].DetailSeviceMoney
                })
              }
            }
            this.tableData = bb
            for (var i = 0; i < this.tableData.length; i++) {
              this.tableData[i].eleMoney = this.getFloat(this.tableData[i].eleMoney)
              this.tableData[i].serMoney = this.getFloat(this.tableData[i].serMoney)
              this.tableData[i].power = this.getFloat(this.tableData[i].power)
              this.tableData[i].money = this.getFloat(this.tableData[i].money)
            }
          } else {
            this.tableData = []
          }

          if (resp.equipPower > 0) {
            this.rowdata.equipPower = resp.equipPower + 'KW'
          }
          if (this.rowdata.orgType == '0') {
            return this.rowdata.orgType = '自营'
          } else if (this.rowdata.orgType == '1') {
            this.rowdata.orgType = '加盟'
          } else {
            this.rowdata.orgType = '互联互通'
          }
        }
      })
    }

  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
}

.iconfont {
  width: 50px;
  height: 50px;
  margin: auto;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/ticketManagement/orderDetail.vue